import { useCallback, useMemo } from 'react';
import * as Yup from 'yup';

import { CONNECTIONS_RANGE_MAX } from '../../../defaultFilters';

export const useConnectionsFilter = ({ setFilters }) => {
  const formSchema = useMemo(
    () =>
      Yup.object().shape({
        connections: Yup.object().nullable(),
      }),
    [],
  );

  const onSubmit = useCallback(
    (values) => {
      const rangeValues = values.connections;

      if (!rangeValues) {
        setFilters({ connections: null });
        return;
      }

      // Independent bounds: drop gteq at the floor and lteq at the cap so a
      // one-sided range stays open-ended (backend checks each bound with .present?).
      const filterValue = {};
      if (rangeValues.min > 0) {
        filterValue.connections_count_gteq = rangeValues.min;
      }
      if (rangeValues.max < CONNECTIONS_RANGE_MAX) {
        filterValue.connections_count_lteq = rangeValues.max;
      }

      setFilters({ connections: Object.keys(filterValue).length ? filterValue : null });
    },
    [setFilters],
  );

  return {
    formSchema,
    onSubmit,
  };
};
